
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 58.5c3.79 0 16.43-7.58 16.43-16.43V15.54H1.57v26.53C1.57 50.92 14.21 58.5 18 58.5z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M26 41.5a8 8 0 01-16 0zM18 15.5v20.77M33.93 40.81c3.19 2.29 6.44 3.69 8.07 3.69 3.79 0 16.43-7.58 16.43-16.43V1.54H25.57v13.78","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M34.56 29.55A8 8 0 0150 32.5H35M42 1.5v17.77","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    